enum Permission {
}

enum OnboardingRegistrationStatus {
  Submitted = 'submitted',
  Pending = 'pending',
  Error = 'error',
  Cancelled = 'cancelled',
  Completed = 'completed',
}

enum RegistrationStatus {
  New = 'New',
  InProgress = 'In Progress',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}

enum AuthenticationMode {
  Auth0 = 'Auth0',
  Azure = 'Azure',
}

enum TenantStatus {
  Creating = 'creating',
  Pending = 'pending',
  Active = 'active',
  Failed = 'failed',
}

enum CloudOrganizationStatus {
  Pending = 'pending',
  Creating = 'creating',
  Created = 'created',
  Error = 'error',
}

enum CloudType {
  Aws = 'aws',
  Azure = 'azure',
}

enum TenantRoleType {
  TenancyAdministrator = 'administrator',
  TenancyManager = 'manager',
  TenancyReader = 'reader',
  TenancyNoAccess = 'notenantaccess',
}

enum UserDetailsRoleType {
  Inherited = 'Inherited',
  Indirect = 'Indirect',
  Direct = 'Direct',
}

enum CloudCustomerType {
  Unknown = 'Unknown',
  AzureCspTelstra = 'AzureCspTelstra',
  AzureCspNonTelstra = 'AzureCspNonTelstra',
}

enum TenantUserInvitationStatus {
  Pending = 'pending',
  Expired = 'expired',
  Verified = 'verified',
  Created = 'created',
}

export {
  Permission,
  OnboardingRegistrationStatus,
  RegistrationStatus,
  AuthenticationMode,
  TenantStatus,
  CloudOrganizationStatus,
  CloudType,
  TenantRoleType,
  CloudCustomerType,
  UserDetailsRoleType,
  TenantUserInvitationStatus,
};
